import { connect } from 'react-redux'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AdministrationAction from '../../actions/AdministrationAction'
import AppStore from '../../../store/AppStore'
import MasterThemeDto from '../../dto/MasterThemeDto'
import HomeAction from '../../../home/actions/HomeAction'
import i18n from 'simple-react-i18n'
import FamilyCard from './FamilyCard'
import FamilyComponent from './FamilyComponent'
import { find, flatten, sumBy, uniq } from 'lodash'
import SourceInformationsPanel from '../sourcesInformations/SourceInformationsPanel'
import Icon from '@material-ui/core/Icon'
import { getPlurialWithNumber } from '../../../utils/StringUtils'

class ThemeInformationPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			theme: null
		}
	}

	componentWillMount() {
		if (this.props.dataTypeStatistics && !this.props.dataTypeStatistics.length) {
			AppStore.dispatch(AdministrationAction.fetchDataTypeStatistics())
		}
		AppStore.dispatch(AdministrationAction.fetchThemes())
		AppStore.dispatch(HomeAction.setTitle(i18n.themes))
	}

	getSiteTypesNbSites = (theme) => {
		const listOfSiteTypes = theme.siteTypes.map(o => {
			const nbSites = (() => {
				const findData = find(this.props.dataTypeStatistics, b => b.typeParameter === o.type)
				return findData ? findData.nbSites : 0
			})()
			return Object.assign({}, o, {
				nbSites: nbSites
			})
		})
		return listOfSiteTypes
	}

	getThemeList() {
		return this.props.themes.map((f, i) => {
			const finalTheme = f.themes.map(t => {
				return Object.assign({}, t, {
					siteTypes: this.getSiteTypesNbSites(t)
				})
			})
			const theme = Object.assign({}, f, {
				themes: finalTheme
			})
			const familyDatas = theme.themes.reduce((acc, v) => {
				acc.layers.push(v.layers.map(l => l.id))
				acc.types.push(v.siteTypes.map(s => s.type))
				return acc
			}, {
				layers: [],
				types: []
			})
			const nbData = flatten(theme.themes).reduce((acc, v) => acc + sumBy(v.siteTypes, 'nbSites'), 0)
			const content = (
				<div>
					<div>
						<b>{ uniq(flatten(familyDatas.layers)).length } </b>
						{ i18n.layersAvailable }
					</div>
					<div>
						<b>{ uniq(flatten(familyDatas.types)).length } </b>
						{ i18n.siteTypesAvailable }
					</div>
					<div>
						<b>{ nbData } </b>
						{ getPlurialWithNumber(i18n.availablePoint, i18n.availablePoints, nbData) }
					</div>
				</div>
			)
			return (
				<FamilyCard key={ i } image={ theme.image } color={ theme.color } title={ theme.title }
							onClick={ () => this.setState({ theme: theme }) }>
					{ content }
				</FamilyCard>
			)
		})
	}

	splitLabel(label) {
		return label.split(' ').join('\n')
	}


	getMainContent() {
		return this.state.theme ? (
			<FamilyComponent theme={ this.state.theme } homeFunction={ () => this.setState({ theme: null }) }/>
		) : (
			<SourceInformationsPanel/>
		)
	}

	getHomeButton() {
		if (this.state.theme) {
			return (
				<div className='row no-margin'>
					<div className='no-margin card col s12 no-padding center-align'
						 onClick={ () => this.setState({ theme: null }) }>
						<div className='home-theme'>
							<Icon className='material-icons'>home</Icon>
						</div>
					</div>
				</div>
			)
		}
		return null
	}

	render() {
		const actif = this.state.theme ? 'theme-actif' : ''
		return (
			<div className={ `row no-margin themes-page ${ actif }` }>
				<div className='col s4 no-padding'>
					<div>
						<div className='row no-margin'>
							{ this.getHomeButton() }
							{ this.getThemeList() }
						</div>
					</div>
				</div>
				<div className='col s8 margin-top-10'>
					<div className='card no-margin'>
						{ this.getMainContent() }
					</div>
				</div>
			</div>
		)
	}
}

ThemeInformationPanel.propTypes = {
	themes: PropTypes.arrayOf(MasterThemeDto),
	dataTypeStatistics: PropTypes.object
}

const mapStateToProps = store => {
	return {
		themes: store.AdministrationReducer.themes,
		dataTypeStatistics: store.AdministrationReducer.dataTypeStatistics
	}
}

export default connect(mapStateToProps)(ThemeInformationPanel)



// WEBPACK FOOTER //
// ./src/administration/components/themeinformation/ThemeInformationPanel.js